export const REQUEST_UNDEFINED = "REQUEST_UNDEFINED";
export const REQUEST_PENDING = "REQUEST_PENDING";
export const REQUEST_SUCCESS = "REQUEST_SUCCESS";
export const REQUEST_FAILURE = "REQUEST_FAILURE";
export const REQUEST_CANCELLED = "REQUEST_CANCELLED";
export const ML_REQUEST_TIMEOUT = "ML_REQUEST_TIMEOUT";